import { useAuth } from '../hooks/useAuth.js';

export function Login() {
  const { login } = useAuth();
  return (
    <div className="flex h-screen flex-col items-center justify-center bg-[var(--xd-bg)]">
      <div className="xd-overlay w-full max-w-sm bg-surface p-8">
        <div className="mb-8 text-center">
          <div className="vault-gradient-text text-3xl font-bold mb-1">xdface vault</div>
          <p className="text-text-muted text-sm">Tu espacio de conocimiento personal</p>
        </div>
        <button
          onClick={login}
          className="w-full rounded-xl bg-xd-action py-3 text-xd-action-fg font-semibold hover:bg-xd-action-hover transition-colors"
        >
          Iniciar sesión
        </button>
      </div>
    </div>
  );
}
